export const EPSILON = 1e-6 // Generally used for hiding an element with opacity

export const TRANSITION_DURATION = 1500 * 1 // ms
